import type Point from "@arcgis/core/geometry/Point";
import { NauticalClasses } from "../constants/NauticalObjects";
import { PendingLighthousePlacement } from "../Context";
import { LighthouseData, Sector } from "./lighthouseConstants";
import { createLighthouseAtPoint } from "./lighthouseUtils";
import type Graphic from "@arcgis/core/Graphic";

export interface CreatePendingLighthouseOptions {
    placement: PendingLighthousePlacement;
    /** Omitted to use the configured default sectors. */
    sectors?: Sector[];
    userName: string | null | undefined;
    entryTitle: string | null | undefined;
    setSelectedFeature: ((feature: Graphic) => void) | null | undefined;
    setLighthouseData: (lighthouseData: LighthouseData) => void;
    setTrueNorth: (trueNorth: number) => void;
    setIsSavingLighthouse: (isSaving: boolean) => void;
    setLoading: (isLoading: boolean) => void;
}

/** Creates the lighthouse a user has placed, with whichever sectors the chosen step produced. */
export const createPendingLighthouse = (options: CreatePendingLighthouseOptions) =>
    createLighthouseAtPoint({
        baseFeature: options.placement.feature,
        center: options.placement.center as Point,
        isFyrstasjon: options.placement.feature.attributes?.klasse === NauticalClasses.FS_Fyrstasjon,
        sectors: options.sectors,
        userName: options.userName,
        entryTitle: options.entryTitle,
        setSelectedFeature: options.setSelectedFeature,
        setLighthouseData: options.setLighthouseData,
        setTrueNorth: options.setTrueNorth,
        setIsSavingLighthouse: options.setIsSavingLighthouse,
        setLoading: options.setLoading,
    });
